import { useState, useEffect } from 'react';
import { MembershipForm } from '../components/forms/MembershipForm';
import { carouselImages } from '../assets/images/placeholders';
import imgSomosCuadrangular from '../assets/images/somos cuadrangular.jpeg';
import { usePublicContent } from '../hooks/usePublicContent';

export const InicioPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  // Carrusel de imágenes
  const images = carouselImages;
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const { getText, getImage, getJson } = usePublicContent('INICIO');
  const heroVerse = getText('hero', 'versiculo', 'Porque donde están dos o tres congregados en mi nombre, allí estoy yo en medio de ellos.');
  const heroReference = getText('hero', 'referencia', '- Mateo 18:20');
  const ctaJoin = getText('hero', 'cta_unirse', 'Únete a Nosotros');
  const ctaSchedule = getText('hero', 'cta_horarios', 'Ver Horarios');

  const identityLabel = getText('identidad', 'label', 'Nuestra identidad');
  const identityTitle = getText('identidad', 'titulo', 'Somos Cuadrangulares');
  const identitySubtitle = getText('identidad', 'subtitulo', 'Fundada en 1947');
  const identityText1 = getText('identidad', 'texto_1', 'La Iglesia Cristiana Cuadrangular es una entidad de naturaleza religiosa, jurídica, exclusiva y sin ánimo de lucro, constituida en 1947 con personería jurídica especial Nro. 2002 de 1996, otorgada por el Ministerio del Interior.');
  const identityText2 = getText('identidad', 'texto_2', 'Regulada por la Constitución Política de Colombia, la ley estatutaria 133 de 1994 y el decreto 354 de 1998. Utilizamos en todos los actos públicos y privados nuestro nombre completo o la sigla ICC, enmarcados dentro de las organizaciones de tendencia en los términos de ley.');
  const identityCta = getText('identidad', 'cta', 'Conocer más');
  const identityImage = getImage('identidad', 'imagen', imgSomosCuadrangular);

  const ministriesLabel = getText('ministerios', 'label', 'Nuestros pilares');
  const ministriesTitle = getText('ministerios', 'titulo', 'Nuestros Ministerios');
  const ministries = getJson<{ icono: string; titulo: string; descripcion: string }[]>('ministerios', 'items', [
    { icono: '✝', titulo: 'Evangelismo', descripcion: 'Llevamos el mensaje de salvación a toda criatura, compartiendo el amor de Cristo en nuestra comunidad.' },
    { icono: '🕊', titulo: 'Sanidad Divina', descripcion: 'Creemos en el poder sanador de Dios y oramos por la restauración física, emocional y espiritual.' },
    { icono: '💧', titulo: 'Bautismo', descripcion: 'Celebramos el bautismo en agua como símbolo de nueva vida en Cristo y obediencia a Su palabra.' },
    { icono: '👑', titulo: 'Segunda Venida', descripcion: 'Esperamos con gozo el regreso glorioso de nuestro Señor Jesucristo como Rey de reyes.' },
  ]);

  const scheduleLabel = getText('horarios', 'label', 'Te esperamos');
  const scheduleTitle = getText('horarios', 'titulo', 'Horarios de Servicio');
  const scheduleItems = getJson<{ icono: string; titulo: string; horas: string; descripcion: string }[]>('horarios', 'items', [
    { icono: '☀️', titulo: 'Culto Dominical', horas: '7:00 AM\n9:30 AM', descripcion: 'Servicio principal de adoración y predicación de la Palabra' },
    { icono: '🙏', titulo: 'Servicio de Oración', horas: '7:00 PM', descripcion: 'Miércoles - Tiempo de intercesión y búsqueda de Dios' },
    { icono: '🎵', titulo: 'Servicio Juvenil', horas: '6:30 PM', descripcion: 'Sábados - Ministerio juvenil con adoración y enseñanza' },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Cambia cada 4 segundos
    
    return () => clearInterval(interval);
  }, [images.length]);
  
  // Función para hacer scroll hacia la sección de horarios
  const scrollToHorarios = () => {
    const horariosSection = document.getElementById('horarios-servicio');
    if (horariosSection) {
      horariosSection.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  return (
    <div className={`transition-colors duration-300 ${
      'bg-gradient-to-br from-gray-50 via-white to-gray-100'
    }`}>
      
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-24 py-12 px-6 min-h-screen flex items-end pb-48">
        {/* Carrusel de imágenes como fondo */}
        <div className="absolute inset-0">
          {images.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                index === currentImageIndex
                  ? 'opacity-100 scale-100'
                  : 'opacity-0 scale-105'
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
          {/* Overlay cálido graduado para legibilidad del texto */}
          <div className="absolute inset-0 bg-gradient-to-b from-stone-950/70 via-stone-900/50 to-stone-950/70"></div>
        </div>
        
        {/* Indicadores del carrusel */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentImageIndex
                  ? 'bg-stone-100 scale-125 shadow-lg'
                  : 'bg-stone-100/60 hover:bg-stone-100/80'
              }`}
            />
          ))}
        </div>
        
        {/* Navegación del carrusel */}
        <button
          onClick={() => setCurrentImageIndex(
            currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1
          )}
          className="absolute left-6 top-1/2 transform -translate-y-1/2 bg-stone-100/20 hover:bg-stone-100/30 backdrop-blur-sm text-stone-100 p-3 rounded-full transition-all duration-300 hover:scale-110 z-20"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        <button
          onClick={() => setCurrentImageIndex(
            currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1
          )}
          className="absolute right-6 top-1/2 transform -translate-y-1/2 bg-stone-100/20 hover:bg-stone-100/30 backdrop-blur-sm text-stone-100 p-3 rounded-full transition-all duration-300 hover:scale-110 z-20"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
        
        <div className="relative max-w-5xl mx-auto text-center z-10 px-6">
          
          {/* Versículo */}
          <div className="max-w-3xl mx-auto mb-8 animate-slide-up delay-300">
            <div className="bg-stone-950/50 backdrop-blur-md rounded-2xl p-6 border border-stone-100/20 shadow-2xl">
              <blockquote className="text-lg md:text-xl lg:text-2xl italic font-serif text-stone-100 drop-shadow-lg mb-4 leading-relaxed" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}>
                "{heroVerse}"
              </blockquote>
              <cite className="text-base md:text-lg text-purple-300 font-semibold drop-shadow-lg" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.6)' }}>
                {heroReference}
              </cite>
            </div>
          </div>

          {/* Botones de Acción */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up delay-500">
            <button 
              onClick={() => setIsFormOpen(true)}
              className="inline-flex items-center gap-2 bg-purple-800 text-stone-50 px-8 py-4 rounded-xl font-semibold text-base md:text-lg hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-purple-900/30 border border-stone-100/20 backdrop-blur-sm"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              {ctaJoin}
              <svg className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
            <button 
              onClick={scrollToHorarios}
              className="inline-flex items-center gap-2 border-2 border-stone-100/40 bg-stone-100/10 backdrop-blur-sm text-stone-100 hover:bg-stone-100 hover:text-purple-800 px-8 py-4 rounded-xl font-semibold text-base md:text-lg transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-stone-900/20"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {ctaSchedule}
              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Sección Somos Cuadrangulares */}
      <section className="py-24 px-6 bg-stone-100">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            
            {/* Columna visual */}
            <div className="lg:col-span-2 flex flex-col items-center justify-center">
              <div className="relative">
                <div className="w-64 h-64 md:w-80 md:h-80 rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/60">
                  <img 
                    src={identityImage} 
                    alt={identityTitle} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gradient-to-br from-purple-600 to-red-500 rounded-full opacity-15 blur-2xl"></div>
              </div>
              <div className="mt-6 text-center">
                <p className="text-stone-500 font-serif italic text-lg">{identitySubtitle}</p>
                <div className="w-16 h-px bg-stone-300 mx-auto mt-2"></div>
              </div>
            </div>

            {/* Columna texto */}
            <div className="lg:col-span-3">
              <div className="text-center lg:text-left">
                <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium">{identityLabel}</p>
                <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2">
                  {identityTitle}
                </h2>
                <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto lg:mx-0 mb-8 rounded-full"></div>
              </div>
              
              <div className="space-y-5 text-stone-700 leading-relaxed text-justify">
                <p>{identityText1}</p>
                <p>{identityText2}</p>
              </div>
              
              <div className="mt-8 text-center lg:text-left">
                <a 
                  href="/nosotros"
                  className="inline-flex items-center px-8 py-3.5 bg-stone-800 text-stone-50 rounded-lg font-semibold text-base hover:bg-stone-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  {identityCta}
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Ministerios */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{ministriesLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {ministriesTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-16 rounded-full"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {ministries.map((m, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-8 text-center border border-stone-200/60 shadow-sm hover:shadow-lg transition-all duration-300 group">
                <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-200 transition-colors">
                  <span className="text-stone-600 text-2xl">{m.icono}</span>
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-3">{m.titulo}</h3>
                <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {m.descripcion}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sección de Horarios */}
      <section id="horarios-servicio" className="py-24 px-6 bg-stone-100">
        <div className="max-w-5xl mx-auto text-center">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium">{scheduleLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2">
            {scheduleTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-16 rounded-full"></div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {scheduleItems.map((item, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-8 shadow-sm border border-stone-200/60 hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-5">
                  <span className="text-stone-600 text-xl">{item.icono}</span>
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-3">{item.titulo}</h3>
                <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
                <div className="text-2xl font-serif font-bold text-stone-700 mb-2 whitespace-pre-line">
                  {item.horas}
                </div>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {item.descripcion}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal de Inscripción */}
      <MembershipForm 
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        eventTitle="Membresía de la Iglesia"
      />
    </div>
  );
};

export default InicioPage;